// extracted by mini-css-extract-plugin
export var headline = "style-module--headline--ce878";
export var navList = "style-module--navList--50c07";
export var navListLink = "style-module--navListLink--bc833";